import { useEffect, useState } from "react";
import LabelAndInput from "../LabelAndInput";
import { TitleColor1 } from "../typography/Typogtaphy";
import ExtraInfoFormContainer from "./utils/ExtraInfoFormContainer";
import { defaultFixedIncomeExtraInfo, FileSrc, FixedIncomeExtraInfo } from "../../AssetContext";
import React from "react";
import ExtraInfoFileUpload, { UploadUtils } from "./utils/ExtraInfoFileUpload";
import { extraInfoGet, extraInfoPut} from "./utils/ExtraInfoUpdate";
import { isThisAsset } from "../../routes/NewAssetExtraInfo.route";

export default function ExtraInfoFixedIncomeForm(props: {
    assetInfo: any, setUpdateFun: any, media: any,
    uploadUtils: UploadUtils
}): JSX.Element {
    const assetInfo = props.assetInfo.payload
    const [images2, setImages2] = useState<FileSrc[]>([])
    const [extraInfo, setExtraInfo] = useState<FixedIncomeExtraInfo>(defaultFixedIncomeExtraInfo);
    const [documents, setDocuments] = useState<FileSrc[]>([])
    const [coownership, setCoownership] = useState<FileSrc[]>([])
    const [prospectus, setProspectus] = useState<FileSrc[]>([])

    const updateField = (field: keyof FixedIncomeExtraInfo, value: string) => {
        setExtraInfo((prev: any) => ({ ...prev, [field]: value }));
    };
    var isSubmitted = isThisAsset("savable", assetInfo)
    type SectionConfig = {
        title: string;
        fields: { label: string; key: keyof FixedIncomeExtraInfo; type?: string; span: number }[];
    };

    const formSections: SectionConfig[] = [
        {
            title: "/ Issuer Information",
            fields: [
                { label: "Issuer Legal Name", key: "issuer_legal_name", span: 6 },
                { label: "LEI", key: "lei", span: 6 },
                { label: "Jurisdiction", key: "jurisdiction", span: 4 },
                { label: "Sector", key: "sector", span: 4 },
                { label: "Credit Rating", key: "credit_rating", span: 4 },
                { label: "Description", key: "description", type: "textarea", span: 12 },
            ],
        },
        {
            title: "/ Bond Information",
            fields: [
                { label: "Bond Name", key: "bond_name", span: 6 },
                { label: "ISIN", key: "isin", span: 6 },
                { label: "Currency", key: "currency", span: 6 },
                { label: "Nominal Value Per Token", key: "nominal_value_per_token", span: 6 },
                { label: "Total Issue Size", key: "total_issue_size", span: 4 },
                { label: "Use of Proceeds", key: "use_of_proceeds", type: "text", span: 4 },
                { label: "Coupon Rate", key: "coupon_rate", span: 4 },
                { label: "Coupon Type", key: "coupon_type", span: 4 },
                { label: "Payment Frequency", key: "payment_frequency", span: 4 },
                { label: "Issue Price", key: "issue_price", span: 4 },
                { label: "Yield at Issue", key: "yield_issue", span: 4 },
                { label: "Settlement Date", key: "settlement_date", span: 4 },
                { label: "Issue Date", key: "issue_date", span: 4 },
                { label: "Maturity Date", key: "maturity_date", span: 4 },
                { label: "Redemption", key: "redemption", span: 4 },
                { label: "Rank", key: "rank", span: 4 },
            ],
        },
        {
            title: "/ Legal Details",
            fields: [
                { label: "Governing Law", key: "governing_law", span: 6 },
                { label: "Prospectus", key: "prospectus", span: 6 },
                { label: "Tax Information", key: "tax_info", span: 6 },
                { label: "Subscription Term", key: "subscription_term", span: 6 },
                { label: "Settlement System", key: "settlement_system", span: 6 },
                { label: "Transfer Restriction", key: "transfer_restriction", span: 6 },
            ],
        },
        {
            title: "/ Security Package",
            fields: [
                { label: "Collateral Assets", key: "collateral_assets", type: "text", span: 6 },
                { label: "Security Agent", key: "security_agent", span: 6 },
                { label: "Affirmative Covenants", key: "affirmative_covenants", type: "text", span: 6 },
                { label: "Negative Covenants", key: "negative_covenants", type: "text", span: 6 },
                { label: "ESG Covenants", key: "esg_covenants", type: "text", span: 4 },
                { label: "Collateral Substitution", key: "collateral_substitution", span: 4 },
                { label: "Enforcement Mechanism", key: "enforcement_mechanism", span: 4 },
            ],
        },
        {
            title: "/ ESG",
            fields: [
                { label: "Green Bond Label", key: "green_bond_label", span: 6 },
                { label: "Second Party Opinion", key: "second_party_opinion", span: 6 },
                { label: "Certification Reference", key: "certification_reference", span: 6 },
                { label: "Impact Metrics", key: "impact_metrics", type: "text", span: 6 },
            ],
        },
    ];

    useEffect(() => {
        props.setUpdateFun({
            fixed_income: 
                extraInfoPut(extraInfo)
        })
    }, [extraInfo]);

    useEffect(() => {
        if (!assetInfo || assetInfo.loading) return;
        const fetchedExtraInfo = extraInfoGet(assetInfo.extra_info);
        setExtraInfo(fetchedExtraInfo);
    }, [assetInfo, assetInfo.loading])

    return <>
        <ExtraInfoFormContainer>
            <TitleColor1 className="col-span-12 text-lg">/ Fixed Income Details</TitleColor1>
            <LabelAndInput
                label="Asset Name"
                value={assetInfo.name}
                fun={() => { }}
                type="disabled"
                className="col-span-6"
            />
            {formSections.map((section) => (
                <React.Fragment key={section.title}>
                    <TitleColor1 className="col-span-12 text-lg">{section.title}</TitleColor1>
                    {section.fields.map((f) => (
                        <LabelAndInput
                            key={f.key}
                            label={f.label}
                            value={extraInfo[f.key] || ""}
                            fun={(value: string) => { updateField(f.key, value) }}
                            type={f.type || "text"}
                            className={`col-span-${f.span || 6}`}
                        />
                    ))}
                </React.Fragment>
            ))}
            <ExtraInfoFileUpload assetName={props.assetInfo} isSubmitted={isSubmitted} coownership={coownership}
                setCoownership={setCoownership} prospectus={prospectus} setProspectus={setProspectus}
                images2={images2} setImages2={setImages2} documents={documents} setDocuments={setDocuments}
                uploadUtils={props.uploadUtils} media={props.media} />
        </ExtraInfoFormContainer >
    </>
}